export enum Gender {
    Male = 0,
    Female = 1
} 